import { Routes } from '@angular/router'
import { authGuard } from './core/auth/auth.guard'

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login').then((m) => m.LoginComponent),
  },
  {
    path: 'set-password/:token',
    loadComponent: () =>
      import('./features/user/set-password/set-password').then(
        (m) => m.SetPasswordComponent,
      ),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () =>
      import('./features/user/reset-password/reset-password').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/user/forgot-password/forgot-password').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'confirm-email/:token',
    loadComponent: () =>
      import('./features/user/email-validation/email-validation').then(
        (m) => m.EmailValidationComponent,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./shared/components/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'patients',
        loadComponent: () =>
          import('./features/patient-info/patient-list/patient-list').then(
            (m) => m.PatientListComponent,
          ),
      },
      {
        path: 'patients/creation',
        loadComponent: () =>
          import('./features/patient-info/patient-creation/patient-creation').then(
            (m) => m.PatientCreationComponent,
          ),
      },
      {
        path: 'patients/:id',
        loadComponent: () =>
          import('./features/patient-info/patient-details/patient-details').then(
            (m) => m.PatientDetailsComponent,
          ),
      },
      {
        path: 'patients/:id/prescription-validation/:prescriptionId',
        loadComponent: () =>
          import('./features/patient-info/patient-prescription-validation/patient-prescription-validation').then(
            (m) => m.PatientPrescriptionValidationComponent,
          ),
      },
      {
        path: 'orders',
        loadComponent: () =>
          import('@/app/features/order/order-list/order-list').then(
            (m) => m.OrderListComponent,
          ),
      },
      {
        path: 'orders/:id',
        loadComponent: () =>
          import('@/app/features/order/order-details/order-detail').then(
            (m) => m.OrderDetail,
          ),
      },
      {
        path: 'order-retrievals',
        loadComponent: () =>
          import('./features/order-retrieval/order-retrieval-list/order-retrieval-list').then(
            (m) => m.OrderRetrievalListComponent,
          ),
      },
      {
        path: 'order-retrievals/:id',
        loadComponent: () =>
          import('@/app/features/order/order-details/order-detail').then(
            (m) => m.OrderDetail,
          ),
      },
      {
        path: 'transfer-requests',
        loadComponent: () =>
          import('./features/transfer-request/transfer-request-list/transfer-request-list').then(
            (m) => m.TransferRequestListComponent,
          ),
      },
      {
        path: 'transfer-requests/:id',
        loadComponent: () =>
          import('./features/transfer-request/transfer-request-details/transfer-request-details').then(
            (m) => m.TransferRequestDetails,
          ),
      },
      {
        path: 'chat',
        loadComponent: () => import('./features/chat/chat').then((m) => m.Chat),
      },
      {
        path: 'agencies',
        loadComponent: () =>
          import('./features/agency/agency-list/agency-list').then(
            (m) => m.AgencyListComponent,
          ),
      },
      {
        path: 'agencies/:id',
        loadComponent: () =>
          import('./features/agency/agency-details/agency-details').then(
            (m) => m.AgencyDetailsComponent,
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/user/user-list/user-list').then(
            (m) => m.UserListComponent,
          ),
      },
      {
        path: 'users/creation',
        loadComponent: () =>
          import('./features/user/user-form/user-form').then(
            (m) => m.UserFormComponent,
          ),
      },
      {
        path: 'doctor-infos/:id',
        loadComponent: () =>
          import('./features/user/doctor-details/doctor-details').then(
            (m) => m.DoctorDetailsComponent,
          ),
      },
      {
        path: 'users/:id',
        loadComponent: () =>
          import('./features/user/user-details/user-details').then(
            (m) => m.UserDetailsComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'patients',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'patients',
  },
]
